<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 v-if="dataId==null">Ajouter un domaine de formation</h4>
        <h4 v-if="dataId!=null">Modifier le domaine {{dataTitre}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
  
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        
        <!-- Product Image -->
        <template v-if="dataAvatar">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataAvatar" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Mettre à jour Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataAvatar = null">Supprimer l'image</vs-button>
          </div>
        </template>
        <!-- titre -->
        <vs-input label="Titre du domaine" v-model="dataTitre" class="mt-5 w-full" titre="item-titre" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-titre')">{{ errors.first('item-titre') }}</span>

         <div class="upload-img mt-5" v-if="!dataAvatar">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Image descriptive du domaine</vs-button>
        </div>
      
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button v-if="dataId==null" class="mr-6" @click="submitData" :disabled="!isFormValid">Ajouter</vs-button>
      <vs-button v-if="dataId!=null" class="mr-6" @click="submitData" :disabled="!isFormValid">Modifier</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
//import axios from "../../../http/axios/index.js"
import moduledomaine from '@/store/domaine/moduledomaine.js'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
     
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        console.log(this.data)
        let {  nom_domaine, id,image } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataAvatar = image
        this.dataTitre = nom_domaine

       console.log(this.dataId,this.dataTitre)
        this.initValues()
       
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
      change_image: false,
      dataAvatar: false,
      change_image: false,
      newformation: false,
      dataTitre: null,  
      dataId: null,
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    domaineData() {
      return this.$store.state.domaine.users
    },
    isSidebarActiveLocal: {
      get() {
        console.log(this.isSidebarActive)
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    
    isFormValid() {
      return !this.errors.any() 
    }
  },
  methods: {
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataAvatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
         this.file = input.target.files[0]
       this.change_image = true
       console.log("this.change_image",this.change_image)
      }
    },
    initValues() {
      if(this.data.id) return
        this.dataId = null
        this.dataTitre = ""
        this.dataAvatar = null
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          this.newformation= true
          console.log('this.newformation',this.newformation)
          if (result) {
            const obj = {
              id: this.dataId,
              nom_domaine: this.dataTitre,
              avatar: this.dataAvatar
            }
                  
            console.log('obj1',obj)
            //this.$store.dispatch("formation/addItem", obj).catch(err => { console.error(err) });    
            //this.showMessage('success', 'Added', 'successfully added') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not Added', 'an error in add: '+ err) })
          
              //this.$store.dispatch("formation/addItem", obj).catch(err => { console.error(err) })
              if(!obj.id){
              console.log('obj',obj)
              this.$store.dispatch("domaine/addItem", obj).then(()   => {  this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'ajouter', 'ajouté avec succès') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'pas ajouté', 'une erreur: '+ err) })
              }else{
                console.log('obj2',obj)
                console.log('obj.avatar',obj.avatar)
               this.$store.dispatch("domaine/updateRecord", obj).then(()   => {  this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'mise à jour', 'mise à jour avec succès') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'pas de mise à jour', 'une erreur: '+ err) })
              }

            this.$emit('closeSidebar')
            this.initValues()
            console.log(this.data)
            //const image = this.file
            //axios.post('http://127.0.0.1:8000/api/addformation',obj,image)
          }
      })
    
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'Domaine '+title,
                text: 'La nouveau domaine '+text
              })
            },
    
  },
  components: {
    VuePerfectScrollbar,
  },
  created() {
  if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
   this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })


  }

    
  
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
